import { DataTable } from "@/components/data-tables/data-table";
import {
    createEmbeddingsColumns,
    EmbeddingsSearchableColumns,
} from "./EmbeddingsDataTableColumns";
import { useDataTable } from "@/hooks/useDataTable";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import { useTranslation } from "react-i18next";

interface Point {
    id: string | number;
    payload: Record<string, any>;
}

interface EmbeddingActions {
    onViewDetails?: (point: Point) => void;
    onDelete?: (pointId: string) => void;
    onRefresh?: () => void;
}

type EmbeddingsDataTableProps = {
    data: Point[];
    actions?: EmbeddingActions;
};

const EmbeddingsDataTable = ({ data, actions }: EmbeddingsDataTableProps) => {
    const { t } = useTranslation();

    // Default action callbacks
    const defaultActions: EmbeddingActions = {
        onViewDetails: (point) => {
            console.log("View details for point:", point);
        },
        onDelete: (pointId) => {
            console.log("Delete point:", pointId);
        },
        onRefresh: () => {
            console.log("Refresh data");
        },
    };

    const finalActions = actions || defaultActions;
    const columns = createEmbeddingsColumns(finalActions);

    const { table } = useDataTable({
        columns: columns as any,
        data,
        pageCount: Math.ceil(data.length / 50),
        searchableColumns: EmbeddingsSearchableColumns as any,
    });

    return (
        <DataTable
            table={table}
            columns={columns as any}
            searchableColumns={EmbeddingsSearchableColumns as any}
            actionButton={
                <Button
                    variant="outline"
                    size="sm"
                    className="h-8"
                    onClick={finalActions.onRefresh}
                >
                    <RefreshCw className="mr-2 size-4" aria-hidden="true" />
                    {t("embeddings.refresh", "Refresh")}
                </Button>
            }
        />
    );
};

export default EmbeddingsDataTable;
